var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransparency(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_901)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1414_901",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2188 0.78125H0.78125V39.2188H39.2188V0.78125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1414_901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.78125C30.6145 0.78125 39.2188 9.38547 39.2188 20C39.2188 30.6145 30.6145 39.2188 20 39.2188C9.38547 39.2188 0.78125 30.6145 0.78125 20C0.78125 9.38547 9.38547 0.78125 20 0.78125Z",
    fill: "#031F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9834 25.7335C23.9194 25.6746 23.6663 25.4773 23.7182 25.4004C24.3625 24.9456 24.9385 24.401 25.4287 23.7832L29.3865 27.7391C29.5542 27.9877 29.6224 28.2903 29.5776 28.5869C29.5329 28.8834 29.3783 29.1524 29.1447 29.3404C28.911 29.5285 28.6153 29.6219 28.316 29.6023C28.0167 29.5826 27.7357 29.4513 27.5287 29.2343C26.3755 28.2968 25.1013 26.807 23.9841 25.7343",
    fill: "#4BAE71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8215 10.4413C15.9021 10.5785 14.0965 11.4029 12.7356 12.7633C11.3747 14.1237 10.5497 15.929 10.4119 17.8483C10.2741 19.7677 10.8326 21.6724 11.9851 23.2133C13.1377 24.7542 14.8069 25.8281 16.687 26.2382C18.5671 26.6482 20.5319 26.3669 22.2214 25.4458C23.9109 24.5247 25.2118 23.0256 25.8857 21.2231C26.5595 19.4207 26.5612 17.4358 25.8904 15.6323C25.2195 13.8288 23.9211 12.3274 22.2332 11.4035C20.8856 10.6656 19.354 10.3316 17.8215 10.4413ZM23.885 21.7029C23.304 22.6556 22.485 23.4407 21.5087 23.981C20.5323 24.5214 19.4321 24.7984 18.3163 24.7847C17.2005 24.7711 16.1074 24.4673 15.1446 23.9033C14.1817 23.3392 13.3822 22.5344 12.8246 21.5677C10.6004 17.6555 13.1449 12.4933 17.6453 12.0599C18.8325 11.9217 20.0347 12.1183 21.116 12.6275C22.1973 13.1368 23.1145 13.9384 23.7641 14.9417C24.4136 15.945 24.7695 17.11 24.7916 18.305C24.8136 19.5 24.5009 20.6773 23.8888 21.7039",
    fill: "#4BAE71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7959 11.8839C16.2449 12.0233 14.7941 12.7097 13.7027 13.8205C12.6113 14.9313 11.9505 16.3941 11.8385 17.9473C11.7265 19.5005 12.1706 21.043 13.0913 22.2989C14.0121 23.5548 15.3495 24.4423 16.8644 24.8027C18.3794 25.1631 19.9732 24.973 21.3608 24.2663C22.7485 23.5597 23.8396 22.3825 24.4391 20.9452C25.0386 19.508 25.1074 17.9044 24.6332 16.4211C24.159 14.9378 23.1727 13.6715 21.8506 12.8486C20.64 12.0945 19.2165 11.7558 17.7959 11.8839ZM17.1475 21.6035C11.7224 20.8309 12.1538 15.6646 17.4408 15.18C19.5082 14.991 23.499 15.6661 23.565 18.3621C23.634 21.1819 19.2509 21.9035 17.1475 21.6035Z",
    fill: "#378C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8155 16.6533C16.4939 17.2917 16.3492 18.0047 16.3965 18.718L16.7847 20.1868C16.1332 19.9758 15.1831 19.5647 14.9006 18.8921C14.4105 17.7159 15.8308 16.8421 16.8155 16.6499",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9366 20.1858C20.1441 19.8441 20.2846 19.466 20.3506 19.0717C20.4518 18.4099 20.3928 17.7335 20.1788 17.0992C20.1429 16.9859 19.8819 16.6271 20.085 16.6508C20.6294 16.8076 21.1325 17.0826 21.5584 17.456C22.7841 18.7027 21.1589 19.9705 19.9354 20.1839",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparency);
export default __webpack_public_path__ + "static/media/Transparency.22900f5043f9fddba35826786f120f41.svg";
export { ForwardRef as ReactComponent };